export const APP_MAIN_ROUTE = '/';
export const FAQ_ROUTE = '/faq';
